import { Injectable } from '@angular/core';

import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';


import { GlobalCfgService } from './globalcfg.service';

/**
*	Provider to do the parts related funtionality.
*/
@Injectable()
export class DashboardService {


    constructor(
		private http: HttpClient,
		private globalCfgService : GlobalCfgService) {
    }
    
    public stats(gcp, dappUserId) {
      var filter =  "";
      if (gcp) {
        filter = "&gcp=" + gcp;
      }
      if (dappUserId) {
        filter += "&dappUserId=" + dappUserId;
      }
		  return this.http.get(environment.apiurl + "/Dashboards/stats?access_token=" + this.globalCfgService.getAccessToken() + filter);
    }
    
    public roi(gcp) {
      var filter =  "";
      if (gcp) {
        filter = "&gcp=" + gcp;
      }
		  return this.http.get(environment.apiurl + "/Dashboards/roi?access_token=" + this.globalCfgService.getAccessToken() + filter);
    }
    
    public statByEventType(gcp, dappUserId) {
      var filter =  "";
      if (gcp) {
        filter = "&gcp=" + gcp;
      }
      if (dappUserId) {
        filter += "&dappUserId=" + dappUserId;
      }
		  return this.http.get(environment.apiurl + "/Dashboards/statByEventType?access_token=" + this.globalCfgService.getAccessToken() + filter);
    }
    
    public topProducts(gcp, dappUserId) {
      var filter =  "";
      if (gcp) {
        filter = "&gcp=" + gcp;
      }
      if (dappUserId) {
        filter += "&dappUserId=" + dappUserId;
      }
		  return this.http.get(environment.apiurl + "/Dashboards/topProducts?access_token=" + this.globalCfgService.getAccessToken() + filter);
    }
    
    public regionWiseIncidents(obj) {
		  return this.http.post(environment.apiurl + "/Dashboards/regionWiseIncidents?access_token=" + this.globalCfgService.getAccessToken() , obj);
	  }

    public incidentType() {
		  return this.http.get(environment.apiurl + "/Dashboards/incidentType?access_token=" + this.globalCfgService.getAccessToken() );
    }


}

	

